import { useQuery } from "@tanstack/react-query";
import { castingsService, queryKeys } from "@/services";
import type { Casting } from "@/types";

interface UseCastingsReturn {
  data: Casting[];
  loading: boolean;
  error: Error | null;
}

export const useCastings = (): UseCastingsReturn => {
  const query = useQuery({
    queryKey: queryKeys.castings.all,
    queryFn: () => castingsService.getAll(),
  });

  return {
    data: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error : null,
  };
};
